export enum RocAssessmentSections {
  ASSESSMENT_OVERVIEW = 'assessment-overview',
  RESUMPTION_OVERVIEW = 'resumption-overview',
  SKILLED_NEEDS = 'skilled-needs',
  ADL_NEEDS = 'adl-needs',
  DISCHARGE_PLANNING = 'discharge-planning',
  AUTHORIZATION = 'authorization',
  VISIT_SCHEDULING = 'visit-scheduling',
  PLAN_OF_CARE = 'plan-of-care',
  SUPERVISORY_REVIEW = 'supervisory-review',
  MEDICATIONS = 'medications',
  VITALS = 'vitals',
  MEDICAL_BACKGROUND = 'medical-background',
  NARRATIVE = 'narrative',
  FINAL_STEPS = 'final-steps'
}

export const RocAssessmentAnchors = [
  {
    key: RocAssessmentSections.ASSESSMENT_OVERVIEW,
    href: '#assessment-overview',
    title: 'Assessment Overview'
  },
  {
    key: RocAssessmentSections.RESUMPTION_OVERVIEW,
    href: '#resumption-overview',
    title: 'Resumption Overview'
  },
  {
    key: RocAssessmentSections.SKILLED_NEEDS,
    href: '#skilled-needs',
    title: 'Skilled Needs'
  },
  {
    key: RocAssessmentSections.ADL_NEEDS,
    href: '#adl-needs',
    title: 'ADL Needs'
  },
  {
    key: RocAssessmentSections.DISCHARGE_PLANNING,
    href: '#discharge-planning',
    title: 'Discharge Planning'
  },
  {
    key: RocAssessmentSections.AUTHORIZATION,
    href: '#authorization',
    title: 'Authorization'
  },
  {
    key: RocAssessmentSections.VISIT_SCHEDULING,
    href: '#visit-scheduling',
    title: 'Visit Scheduling'
  },
  {
    key: RocAssessmentSections.PLAN_OF_CARE,
    href: '#plan-of-care',
    title: 'Plan of Care'
  },
  {
    key: RocAssessmentSections.SUPERVISORY_REVIEW,
    href: '#supervisory-review',
    title: 'Supervisory Review'
  },
  {
    key: RocAssessmentSections.MEDICATIONS,
    href: '#medications',
    title: 'Medications'
  },
  {
    key: RocAssessmentSections.VITALS,
    href: '#vitals',
    title: 'Vitals'
  },
  {
    key: RocAssessmentSections.MEDICAL_BACKGROUND,
    href: '#medical-background',
    title: 'Medical Background'
  },
  {
    key: RocAssessmentSections.NARRATIVE,
    href: '#narrative',
    title: 'Narrative'
  },
  {
    key: RocAssessmentSections.FINAL_STEPS,
    href: '#final-steps',
    title: 'Final Steps'
  }
]

// Add sections here as they are migrated from controlled to uncontrolled
export const UNCONTROLLED_FORM_SECTION: Set<RocAssessmentSections> = new Set([
  RocAssessmentSections.ASSESSMENT_OVERVIEW,
  RocAssessmentSections.RESUMPTION_OVERVIEW,
  RocAssessmentSections.SKILLED_NEEDS,
  RocAssessmentSections.ADL_NEEDS,
  RocAssessmentSections.DISCHARGE_PLANNING,
  RocAssessmentSections.VISIT_SCHEDULING,
  RocAssessmentSections.AUTHORIZATION,
  // RocAssessmentSections.VISIT_SCHEDULING,
  RocAssessmentSections.PLAN_OF_CARE,
  // RocAssessmentSections.PLAN_OF_CARE,
  RocAssessmentSections.SUPERVISORY_REVIEW,
  RocAssessmentSections.VITALS,
  // RocAssessmentSections.MEDICATIONS,
  // RocAssessmentSections.MEDICAL_BACKGROUND,
  RocAssessmentSections.NARRATIVE,
  RocAssessmentSections.FINAL_STEPS
])
